import {Injectable} from "@angular/core";
import {BaseService} from "../base.service";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {catchError, tap} from "rxjs/operators";
import {SimpleEntity} from "../../models/simple-entity.model";


@Injectable()
export class BranchService extends BaseService<any>{
  constructor(public httpClient: HttpClient) {
    super(
      'company',
      httpClient);
  }

  autocomplete = this.getBranchByCompany;


  getBranchByCompany(companyId: number): Observable<SimpleEntity[]> {
    let uri = new URL(environment.baseUrl + '/company/getBranchByCompany').updateQueryParam({
      companyId
    })
    return this.httpClient.get<SimpleEntity[]>(uri.toString(), { withCredentials: false, headers: this.httpHeaders() })
      .pipe(
        tap(),
        catchError(this.handleError)
      )
  }

}
